import { iframeStep } from './iframeStep';
import { infoStep } from './infoStep';

export const movement = {
  namespaced: true,
  modules: {
    iframeStep,
    infoStep
  }
};
